import {
  useGenericSubjectList,
  type GenericSubject,
} from "@twinkltech/curriculum-architect-domain-hooks";

import { ExploreSubjectListContents } from "./ExploreSubjectListContents.tsx";

export const ExploreSubjectListContentsContainer = () => {
  const { data, error, isLoading } = useGenericSubjectList();

  const { activeSubjectList, addOnSubjectList, comingSoonSubjectList } =
    data?.reduce(
      (acc, subject) => {
        if (subject.comingSoon === true) {
          acc.comingSoonSubjectList.push(subject);
        } else if (subject.userHasAccess === true) {
          acc.activeSubjectList.push(subject);
        } else if (subject.userHasAccess === false) {
          acc.addOnSubjectList.push(subject);
        }
        return acc;
      },
      {
        activeSubjectList: [] as GenericSubject[],
        addOnSubjectList: [] as GenericSubject[],
        comingSoonSubjectList: [] as GenericSubject[],
      }
    ) ?? {
      activeSubjectList: [] as GenericSubject[],
      addOnSubjectList: [] as GenericSubject[],
      comingSoonSubjectList: [] as GenericSubject[],
    };

  return (
    <ExploreSubjectListContents
      activeSubjectList={activeSubjectList}
      addOnSubjectList={addOnSubjectList}
      comingSoonSubjectList={comingSoonSubjectList}
      error={error}
      isLoading={isLoading}
    />
  );
};
